/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import AddIcon from '@atlaskit/icon/core/migration/add--editor-add';
import ChevronDownIcon from '@atlaskit/icon/utility/migration/chevron-down';
import { triggerWrapper } from './styles';
var DropDownButtonIcon = /*#__PURE__*/React.memo(function (props) {
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("span", {
      css: triggerWrapper
    }, jsx(AddIcon, {
      label: props.label,
      color: "currentColor",
      spacing: "spacious"
    }), jsx("span", null, jsx(ChevronDownIcon, {
      label: "",
      color: "currentColor",
      LEGACY_margin: "0 0 0 -8px"
    })))
  );
});
export var DropDownButton = /*#__PURE__*/React.memo(function (props) {
  return jsx(ToolbarButton, {
    ref: props.handleRef,
    selected: props.selected,
    disabled: props.disabled,
    onClick: props.onClick,
    onKeyDown: props.onKeyDown,
    spacing: props.spacing,
    "aria-expanded": props['aria-expanded'],
    "aria-haspopup": props['aria-haspopup'],
    "aria-keyshortcuts": props['aria-keyshortcuts'],
    "aria-label": "".concat(props.label),
    iconBefore: jsx(DropDownButtonIcon, {
      label: ""
    }),
    title: jsx(ToolTipContent, {
      description: props.label,
      shortcutOverride: "/"
    })
  });
});